import React, { useContext, useEffect, useRef, useState } from "react";
import _ from "lodash";
import { useParams, useNavigate } from "react-router-dom";
import LoaderComponent from "../../Components/Shared/LoaderComponent";
import NoTemplate from "../../Components/Template/NoTemplate";
import {
  formActionEnum,
  templateActionEnum,
  colors,
  jsonKeyMapping,
  ROOT_PATH,
  sessionStorageKey
} from "../../Config/Constants";
import FormDataContext from "../../Contexts/FormData.context";
import TemplateDataContext from "../../Contexts/TemplateData.context";
import useLoadJson from "../../Hooks/LoadJson";

const LoadTemplate = () => {
  const { state: templateState, dispatch } = useContext(TemplateDataContext);
  const { templateType, state } = useParams();
  const { dispatch: formDispatch } = useContext(FormDataContext);
  const [isContentLoaded, setIsContentLoaded] = useState(false);
   /* Reset Previous Value */
  useEffect(() => {
    // Clear session first
  sessionStorage.removeItem(sessionStorageKey.TEMPLATE_STATE);
  sessionStorage.removeItem(sessionStorageKey.FORM_STATE);
  sessionStorage.clear();
    formDispatch({ type: formActionEnum.RESET_FORM_DATA });
    formDispatch({ type: formActionEnum.RESET_STEP_DATA });
    formDispatch({ type: formActionEnum.SET_COLOR, payload: colors[9] });
    formDispatch({ type: formActionEnum.SET_DOC_ID, payload: "" });
    formDispatch({ type: formActionEnum.SET_PARAGRAPH, payload: {} });
    formDispatch({ type: formActionEnum.RESET_BLANK_FORM_DATA });
    formDispatch({ type: formActionEnum.RESET });
    dispatch({ type: templateActionEnum.SET_STEP_FLAG, payload: false });
    dispatch({ type: templateActionEnum.RESET});
    dispatch({ type: templateActionEnum.SET_NAVBAR_STATE, payload: false });
    return () => {};
  }, [templateType]);

  useEffect(() => {
    if (state) {
      dispatch({ type: templateActionEnum.SET_SELECTED_STATE, payload: state });
    } else {
      dispatch({ type: templateActionEnum.SET_SELECTED_STATE, payload: "" });
    }
    return () => {};
  }, [state]);

  if (state) {
    /* Load Json */
    useLoadJson({
      endPoint: `state-specific/${templateType}`,
      jsonFileName: `${_.capitalize(state)}.json`,
      state: _.capitalize(state),
      setIsContentLoaded: setIsContentLoaded
    });
  } else {
    useLoadJson({
      endPoint: templateType || "",
      jsonFileName: `${templateType}.json`,
      setIsContentLoaded: setIsContentLoaded
    });
  }

  const navigate = useNavigate();
  const navigatedRef = useRef(false);

  // Auto navigate to first step after loading completes (show loader until then)
  useEffect(() => {
    if (navigatedRef.current) return;
    if (!isContentLoaded) return;
    const { isLoading, templateKeys, templates, templatePath, selectedState } =
      templateState;
    if (isLoading) return; // still loading
    if (templateState.noTemplateFound) return; // nothing to navigate to
    if (!templateKeys || templateKeys.length === 0) return; // wait for keys
    const templateKey = templateKeys[0] || "temp1";
    const templateObj = templates[templateKey];
    if (!templateObj || !templateObj[jsonKeyMapping.STEPS]) return; // steps not ready
    const steps = templateObj[jsonKeyMapping.STEPS];
    if (!Array.isArray(steps) || steps.length === 0) return;
    const firstRealStep = steps.find(
      (step: any) =>
        step[jsonKeyMapping.FORM_GROUP] &&
        Array.isArray(step[jsonKeyMapping.FORM_GROUP]) &&
        step[jsonKeyMapping.FORM_GROUP].length > 0
    );
    const initialStepSlug = (firstRealStep || steps[0])[jsonKeyMapping.SLUGIFY];
    let route: string;
    if (templatePath.startsWith("state-specific/")) {
      // templatePath = "state-specific/<templateType>"
      const parts = templatePath.split("/"); // ["state-specific", templateType]
      const templateTypePart = parts[1];
      const stateSlug = state || selectedState;
      route = `/${ROOT_PATH}/state-specific/${templateTypePart}/${stateSlug}/${templateKey}/${initialStepSlug}`;
    } else {
      route = `/${ROOT_PATH}/${templatePath}/${templateKey}/${initialStepSlug}`;
    }
    navigatedRef.current = true;
    navigate(route, { replace: true });
  }, [templateState, navigate, isContentLoaded]);

  if (templateState.noTemplateFound) return <NoTemplate />;
  return <LoaderComponent />;
};

export default LoadTemplate;

